import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "wrapper",
  class: "file-av-wrapper"
}
const _hoisted_2 = { class: "file-av-stop" }
const _hoisted_3 = { class: "file-av-play" }
const _hoisted_4 = { class: "file-error-message file-error-message-client" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "file-preview-overlay" }, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "thumbnail",
  style: {"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","overflow":"hidden"}
}
const _hoisted_7 = ["href", "title"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "file-ext" }
const _hoisted_11 = { class: "file-size" }
const _hoisted_12 = ["disabled", "value"]
const _hoisted_13 = {
  key: 1,
  class: "file-name-edit-icon"
}
const _hoisted_14 = { class: "file-name-text" }
const _hoisted_15 = {
  key: 0,
  class: "file-warning"
}
const _hoisted_16 = {
  key: 3,
  class: "image-dimension"
}
const _hoisted_17 = { class: "image-dimension-width" }
const _hoisted_18 = { class: "image-dimension-height" }
const _hoisted_19 = ["href", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueFileIcon = _resolveComponent("VueFileIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'file-preview-wrapper-' + _ctx.fileRecord.ext(),
      _ctx.fileRecord.isImage() ? 'file-preview-wrapper-image' : 'file-preview-wrapper-other',
      'file-category-' + _ctx.fileRecord.icon().category,
      { 'file-is-playing-av': _ctx.fileRecord.isPlayingAv },
      { 'is-deletable': _ctx.deletable === true },
      { 'is-editable': _ctx.editable === true },
      { 'is-edit-input-focused': _ctx.isEditInputFocused },
      { 'has-error': _ctx.fileRecord.error },
    ])
  }, [
    (_ctx.fileRecord.isPlayableAudio() || _ctx.fileRecord.isPlayableVideo())
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "file-av-action",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.playAv(_ctx.fileRecord)))
          }, [
            _createElementVNode("span", _hoisted_2, [
              _createVNode(_component_VueFileIcon, { name: "system-close" })
            ]),
            _createElementVNode("span", _hoisted_3, [
              _createVNode(_component_VueFileIcon, { name: "system-file-av-play" })
            ])
          ])
        ], 512))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: _normalizeClass(["file-preview", {
        'image-preview': _ctx.fileRecord.isImage(),
        'other-preview': !_ctx.fileRecord.isImage(),
        'dark-content': _ctx.fileRecord.isImage() && _ctx.fileRecord.isDarkColor(),
      }]),
      style: _normalizeStyle({
        'background-color': _ctx.fileRecord.color(),
      })
    }, [
      (_ctx.fileRecord.error)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "file-error-wrapper",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dismissError()))
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.fileRecord.getErrorMessage(_ctx.errorText)), 1)
          ]))
        : _createCommentVNode("", true),
      _hoisted_5,
      (_ctx.fileRecord.isImage() || _ctx.fileRecord.isPlayableVideo())
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
            (_ctx.hasLinkableUrl)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _ctx.fileRecord.url(),
                  target: "_blank",
                  title: _ctx.fileRecord.name()
                }, [
                  _createElementVNode("img", {
                    class: "file-preview-img",
                    src: _ctx.fileRecord.src()
                  }, null, 8, _hoisted_8)
                ], 8, _hoisted_7))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  class: "file-preview-img",
                  src: _ctx.fileRecord.src()
                }, null, 8, _hoisted_9))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.fileRecord.ext()), 1),
      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.fileRecord.size()), 1),
      (_ctx.deletable)
        ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            class: "file-delete",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.removeFileRecord(_ctx.fileRecord)), ["prevent"])),
            onTouchstart: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filenameClearPressed())),
            onMousedown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.filenameClearPressed()))
          }, [
            _createVNode(_component_VueFileIcon, { name: "system-close" })
          ], 32))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        class: "file-name",
        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.editFileName()))
      }, [
        (_ctx.editable === true)
          ? (_openBlock(), _createElementBlock("input", {
              key: 0,
              class: "file-name-input",
              ref: "input",
              disabled: _ctx.disabled === true,
              type: "text",
              value: _ctx.fileRecord.name(true),
              onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.editInputFocused())),
              onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editInputBlured())),
              onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.filenameChanged())),
              onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.filenameChanged())),
              onKeyup: [
                _cache[9] || (_cache[9] = _withKeys(($event: any) => (_ctx.filenameChanged(true)), ["enter"])),
                _cache[10] || (_cache[10] = _withKeys(($event: any) => (_ctx.filenameChanged(false)), ["esc"]))
              ]
            }, null, 40, _hoisted_12))
          : _createCommentVNode("", true),
        (_ctx.editable === true)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
              _createVNode(_component_VueFileIcon, { name: "system-file-name-edit" })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_14, [
          _createTextVNode(_toDisplayString(_ctx.fileRecord.name(true)), 1),
          (_ctx.fileRecord.isDuplicateFile)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, " - Warning: File previously uploaded."))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.fileRecord.dimensions.width && _ctx.fileRecord.dimensions.height)
        ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.fileRecord.dimensions.width), 1),
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.fileRecord.dimensions.height), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.fileRecord.hasProgress())
        ? (_openBlock(), _createElementBlock("span", {
            key: 4,
            class: _normalizeClass(["file-progress", {
              'file-progress-full' : _ctx.fileRecord.progress() >= 99.9999,
            'file-progress-done': _ctx.fileRecord.progress() >= 100,
            'has-file-progress': _ctx.fileRecord.progress() > 0,
            }])
          }, [
            _createElementVNode("span", {
              class: "file-progress-bar",
              style: _normalizeStyle({ width: _ctx.fileRecord.progress() + '%' })
            }, null, 4)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.fileRecord.isDuplicateFile? 'file-icon bg-warning': 'file-icon')
      }, [
        (_ctx.hasLinkableUrl)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _ctx.fileRecord.url(),
              target: "_blank",
              title: _ctx.fileRecord.name()
            }, [
              _createVNode(_component_VueFileIcon, {
                ext: _ctx.fileRecord.ext()
              }, null, 8, ["ext"])
            ], 8, _hoisted_19))
          : (_openBlock(), _createBlock(_component_VueFileIcon, {
              key: 1,
              ext: _ctx.fileRecord.ext()
            }, null, 8, ["ext"]))
      ], 2)
    ], 6)
  ], 2))
}